import moment from "moment-jalaali";

export default function useExportExcel(tvWidget) {
  const getData = () => {
    if (!tvWidget) return;

    const seriesData =
      tvWidget.chart().getSeries().data().bars()._items || [];

    let tableHTML = "<table border='2px'><tr bgcolor='#87AFC6'>";
    tableHTML += "<tr><th>تاریخ</th><th>آخرین قیمت</th></tr>";

    const visibleFrom = tvWidget.chart().getVisibleRange().from;
    const visibleTo = tvWidget.chart().getVisibleRange().to;

    seriesData.forEach((item) => {
      const timestamp = item.value[0];
      const closePrice = item.value[4];

      if (timestamp >= visibleFrom && timestamp <= visibleTo) {
        const date = moment(timestamp * 1000).format("jYYYY/jMM/jD");
        tableHTML += `<tr><td>${date}</td><td>${closePrice}</td></tr>`;
      }
    });

    tableHTML += "</table>";

    // Clean HTML
    tableHTML = tableHTML
      .replace(/<A[^>]*>|<\/A>/g, "")
      .replace(/<img[^>]*>/gi, "")
      .replace(/<input[^>]*>|<\/input>/gi, "");

    // Excel template
    const uri = "data:application/vnd.ms-excel;base64,";
    const template =
      `<html xmlns:o="urn:schemas-microsoft-com:office:office"
             xmlns:x="urn:schemas-microsoft-com:office:excel"
             xmlns="http://www.w3.org/TR/REC-html40">
        <head>
          <!--[if gte mso 9]>
            <xml>
              <x:ExcelWorkbook>
                <x:ExcelWorksheets>
                  <x:ExcelWorksheet>
                    <x:Name>{worksheet}</x:Name>
                    <x:WorksheetOptions><x:DisplayGridlines/></x:WorksheetOptions>
                  </x:ExcelWorksheet>
                </x:ExcelWorksheets>
              </x:ExcelWorkbook>
            </xml>
          <![endif]-->
        </head>
        <body><table>{table}</table></body>
      </html>`;

    const base64 = (s) =>
      window.btoa(unescape(encodeURIComponent(s)));

    const formatted = template.replace(/{(\w+)}/g, (m, p) =>
      p === "table" ? tableHTML : "Worksheet"
    );

    // Create and trigger download
    const link = document.createElement("a");
    link.download =
      "data_" +
      tvWidget._options.symbol +
      "_" +
      new Date().getTime() +
      ".xls";
    link.href = uri + base64(formatted);
    link.click();
  };

  return getData;
}